import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSpecialProducts } from "../../../actions/products";
import useStyles from "./styles";
import ProductBox from "../ProductBox";
import Carousel from "react-multi-carousel";
import { splitArray } from "../../../helpers/common";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material";

export default function AvonsSpecials() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const specialProducts = useSelector((state) => state.products.bestSellers) || [];

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(768));

  const specialProductsOne = splitArray(specialProducts)[0];
  const specialProductsTwo = splitArray(specialProducts)[1];

  useEffect(() => {
    dispatch(getSpecialProducts("Avon's Specials"));
  }, [dispatch]);

  const responsive = {
    default: {
      breakpoint: { max: 4000, min: 992 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 992, min: 600 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1.5,
    },
  };

  return specialProducts?.length > 0 ? (
    <div className={`${classes.avonsSpecialsSec}`}>
      <div className='container'>
        <div className={classes.sectionHeader}>
          <h2 className={classes.heading}>Avon's Specials</h2>
          <p className={classes.subheading}>
            Discover our exclusive collection of premium Indian snacks, carefully crafted with traditional recipes and the finest ingredients
          </p>
        </div>
      </div>
      
      <div className={`productSliderSec`}>
        <div className='container'>
          <Carousel
            draggable={true}
            keyBoardControl={true}
            responsive={responsive}
            infinite={true}
            partialVisible={"false"}
            autoPlaySpeed={4000}
            arrows={true}
            autoPlay={false}
            dotListClass='custom-dot-list-style'
            removeArrowOnDeviceType={["mobile"]}
            showDots={false}
          >
            {specialProductsOne?.map((product) => (
              <ProductBox key={"avonsSpecials-" + product.id} product={product} />
            ))}
          </Carousel>
        </div>
      </div>

      {specialProductsTwo?.length > 0 && (
        <div
          className={`productSliderSec ${!isMobile ? "mt-3" : ""} `}
          style={{ marginTop: isMobile ? -20 : 0 }}
        >
          <div className='container'>
            <Carousel
              draggable={true}
              keyBoardControl={true}
              responsive={responsive}
              infinite={true}
              partialVisible={"false"}
              autoPlaySpeed={4000}
              arrows={true}
              autoPlay={false}
              dotListClass='custom-dot-list-style'
              removeArrowOnDeviceType={["mobile"]}
              showDots={false}
            >
              {specialProductsTwo?.map((product) => (
                <ProductBox
                  key={"avonsSpecials-" + product.id}
                  product={product}
                />
              ))}
            </Carousel>
          </div>
        </div>
      )}
    </div>
  ) : null;
}
